import React, { useEffect, useState } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import ContainerPage from "../../../components/ContainerPage/ContainerPage"
import PageTitle from "../../../components/PageTitle/PageTitle"

import ContactGroups from "../ContactGroups/ContactGroups"
import TriggersManagement from "../WorkflowControl/TriggersManagement"
import CompanySettings from "../CompanySettings/CompanySettings"
import PaymentExport from "../PaymentExport/PaymentExport"
import PaymentProcessingSettings from "../PaymentProcessing/PaymentProcessing"
import EnrolledReport from "../EnrolledReport/EnrolledReport"
import SideBar from "../SideBar/SideBar"
import { StorageGetItem, USER } from "../../../lib/storage"

const Settings = () => {
  const [userId, setUserId] = useState('')
  const [activeTab, setActiveTab] = useState('contactGroups')
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    StorageGetItem(USER).then(result => {
      setUserId(result._id)
    })
  }, [])

  // Визначити активний таб на основі URL або state
  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab)
    } else if (location.pathname.includes('/triggers')) {
      setActiveTab('workflowControl')
    }
  }, [location.pathname, location.state])

  const renderTabContent = () => {
    switch (activeTab) {
      case 'contactGroups':
        return <ContactGroups userId={userId} />
      case 'workflowControl':
        return <TriggersManagement />
      case 'companySettings':
        return <CompanySettings />
      case 'paymentExport':
        return <PaymentExport />
      case 'paymentProcessing':
        return <PaymentProcessingSettings />
      case 'enrolledReport':
        return <EnrolledReport />
      default:
        return <ContactGroups userId={userId} />
    }
  }

  return (
    <ContainerPage>
      <PageTitle title="Settings" />
      <div className="flex flex-row justify-between">
        <SideBar setActiveTab={setActiveTab} activeTab={activeTab} />
        <div className="flex-1 min-w-0 ml-6 p-4 bg-surface shadow-card rounded-2xl">
          {renderTabContent()}
        </div>
      </div>
    </ContainerPage>
  )
}

export default Settings